import User from "models/user";
import { SCREENING_FLOW, ScreeningFlow } from "models/screening-flow";
import { removePreSelectedClinicId } from "utils/local-storage";
import {
    removeAppointmentHold,
    removeBookingFollowUpType,
    removePreSelectedLabType,
} from "utils/session-storage";

export type ScreeningFlowSwitchBlockReason = "already_booked";

export function clearInProgressBookingSelections(): void {
    removePreSelectedLabType();
    removeBookingFollowUpType();
    removeAppointmentHold();
    removePreSelectedClinicId();
}

export function getScreeningFlowSwitchBlockReason(
    authUser: User | undefined,
    targetFlow: ScreeningFlow
): ScreeningFlowSwitchBlockReason | undefined {
    if (!authUser) {
        return undefined;
    }

    if (
        targetFlow === SCREENING_FLOW.HPV &&
        !authUser.isLastHpvAppointmentDone
    ) {
        return "already_booked";
    }

    if (
        targetFlow === SCREENING_FLOW.STI &&
        !authUser.isLastStiAppointmentDone
    ) {
        return "already_booked";
    }

    return undefined;
}

export function getOtherScreeningFlow(
    currentFlow: ScreeningFlow
): ScreeningFlow {
    return currentFlow === SCREENING_FLOW.HPV
        ? SCREENING_FLOW.STI
        : SCREENING_FLOW.HPV;
}
